/* Marks the transparent home header while it overlaps the film hero or the video grid, so it stays frosted through it. */
let frame = 0;

function update() {
  frame = 0;
  const header = document.querySelector('#header-component[transparent]');
  const film = document.querySelector('.luren-film, .luren-reel');
  if (!header) return;
  header.toggleAttribute('data-over-film', Boolean(film) && film.getBoundingClientRect().bottom > header.offsetHeight);
}

function queue() {
  if (!frame) frame = requestAnimationFrame(update);
}

// Capture phase: the storefront can scroll an inner container instead of the window.
document.addEventListener('scroll', queue, { passive: true, capture: true });
addEventListener('resize', queue);
document.addEventListener('shopify:section:load', queue);
update();
